import React, { ReactElement, useState, useRef } from 'react';
import { Button, Text, VStack } from '@chakra-ui/react';
import { BlockInput } from 'components/worksheet/common/BlockInput';
import { useWorksheetSession } from 'contexts/WorksheetSessionContext';
import { TextQuestionOrientationAnswer } from '../TextQuestionOrientationAnswer';
import { TQBlockProps, TQBlockUpdate } from '../TextQuestionBlock';

type Props = TQBlockProps & {
  onBlockUpdate: (updates: TQBlockUpdate) => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StudentTQBlock = ({ block, editor, onBlockUpdate }: Props): ReactElement => {
  const [answer, setAnswer] = useState<string>(block.props.answer || '');
  const [shouldShowResults, setShouldShowResults] = useState<boolean>(
    block.props.isSubmitted || false
  );
  const answerRef = useRef<HTMLTextAreaElement>(null);
  const worksheetSession = useWorksheetSession();

  const updateAnswer = (): void => {
    if (!answer.trim()) {
      // TODO: handle no answer case
      // return;
    }

    onBlockUpdate({
      answer,
      isSubmitted: true,
    });
    setShouldShowResults(true);
    // Only auto-save if in student session context (has provider)
    if (worksheetSession?.onBlockSubmit) {
      worksheetSession.onBlockSubmit(editor.document);
    }
  };

  const onAnswerChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    setAnswer(e.target.value);
  };

  return (
    <VStack
      border="default"
      borderColor="border.accent"
      borderRadius="l"
      p="l"
      gap="l"
      width="100%"
      alignItems="flex-start"
      contentEditable={false}
      bg="grey.white"
    >
      <Text
        textStyle={{ base: 'body.m.medium', md: 'h4.medium' }}
        color="text.primary"
        whiteSpace="pre-line"
      >
        {block.props.question}
      </Text>

      <VStack gap="15px" width="100%" alignItems="flex-start">
        <BlockInput
          name="answer"
          value={answer}
          initialRows={3}
          onChange={onAnswerChange}
          placeholder="Gib deine Antwort hier ein..."
          disabled={shouldShowResults}
          ref={answerRef}
        />

        {shouldShowResults && (
          <>
            <Text textStyle="body.m.regular" color="text.quaternary">
              Antwort gespeichert!
            </Text>
            <TextQuestionOrientationAnswer correctAnswer={block.props.correctAnswer} />
          </>
        )}
      </VStack>
      {!shouldShowResults && (
        <Button type="submit" variant="primary" onClick={updateAnswer}>
          Abschicken
        </Button>
      )}
    </VStack>
  );
};
